export default __webpack_public_path__ + "static/media/Quadra.3c555e2d.png";